import {
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
  ViewRef
} from '@angular/core';
import {ConfigService} from '../config/config.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PopupComponent} from '../popup/popup.component';
import {MatDialog} from '@angular/material/dialog';
import { backendAddress } from '../../environments/environment';
import {TranslateService} from '@ngx-translate/core';
import {LanguageService} from '../service/language.service';

@Component({
    selector: 'app-my-offers',
    templateUrl: './my-offers.component.html',
    styleUrls: ['./my-offers.component.scss'],
    standalone: false
})
export class MyOffersComponent implements OnInit {
  @ViewChildren('lazyElement', { read: ElementRef }) lazyElements!: QueryList<ElementRef>;
  @Input() loggedInUser: any;

  constructor(private api: ConfigService, private snackBar: MatSnackBar, public dialog: MatDialog,
              // tslint:disable-next-line:variable-name
              private translate: TranslateService, private _language: LanguageService) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }


  isLoaderVisible = false;
  offers = [
    {
      id: 1,
      user_id: null,
      art_object_id: 14,
      email: '',
      name: '',
      phone_number: '',
      offer: '',
      details: '',
      status: 0,
      created_at: '',
      updated_at: '',
      art_object: {
        id: 0,
        title: '',
        description: '',
        picture_category_id: 0,
        availability: 0,
        dimension: '',
        technique: '',
        year: 0,
        file_name: '',
        user_id: 0,
        created_at: '',
        updated_at: '',
        file_path: '',
      }
    }
  ];
  states = [
    {
      id: 1,
      name: 'statePending',
    },
    {
      id: 2,
      name: 'stateApproved',
    }
  ];
  backendAddress = backendAddress.value;
  isDataReady = false;

  modifyDataUpdated(): void {
    this.offers.forEach(offer => {
      // @ts-ignore
      const offerSplit = offer.updated_at.split('T');
      // @ts-ignore
      offer.updated_at = offerSplit[0];
    });
  }
  seeBuyerDetails(offer: any): void {
    let message = '';
    this.translate.get('offerMadeBy').subscribe(madeBy => {
      this.translate.get('withEmail').subscribe(withEmail => {
        this.translate.get('andPhoneNumber').subscribe(andPhoneNr => {
          this.translate.get('otherDetails').subscribe(otherDetails => {
            message = madeBy + offer.name + '\'' + withEmail + offer.email + '\'' +
              andPhoneNr + offer.phone_number + '\'';
            if (offer.details) {
              message += otherDetails + offer.details + '\'';
            }
          });
        });
      });
    });
    this.dialog.open(PopupComponent, {
      data: {popupText: message, popupButtonsNotVsible: 'da'},
      disableClose: true
    });
  }
  getOffers(): void {
    this.isLoaderVisible = true;
    this.api.getMyOffers().subscribe(data => {
        // @ts-ignore
        this.offers = data.reverse();
        if (this.offers.length > 0){
          this.modifyDataUpdated();
        }
        this.isLoaderVisible = false;
        this.isDataReady = true;
        setTimeout(() => {
          this.initiateLazyLoad();
        }, 0);
      },
      error => {
        this.isLoaderVisible = false;
        this.isDataReady = true;
        setTimeout(() => {
          this.initiateLazyLoad();
        }, 0);
        console.log('getLoggedInUserArtObjects error', error);
        this.isLoaderVisible = false;
        this.isDataReady = true;
        this.translate.get('errorOccurred').subscribe(msg => {
          this.snackBar.open(msg, '',
            {duration: 3000, panelClass: 'error-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
          this.isLoaderVisible = false;
        });
      // todo

      //   const data = [
      //     {
      //       id: 18,
      //       user_id: null,
      //       art_object_id: 87,
      //       email: 'andreea.lupu@scriptics.ro',
      //       name: 'Andreea-Monica LUPU',
      //       phone_number: '0740241423',
      //       offer: 'no-price',
      //       details: 'lallalaa',
      //       status: 2,
      //       created_at: '2025-04-05T17:08:16.000000Z',
      //       updated_at: '2025-04-05T17:08:33.000000Z',
      //       art_object: {
      //         id: 87,
      //         title: 'tablou 8 martie',
      //         description: 'Tablou cu art print de 8 martie',
      //         picture_category_id: 5,
      //         availability: 0,
      //         dimension: '20x30cm',
      //         technique: 'art print',
      //         year: 2025,
      //         file_name: '165.jpg',
      //         price:  null,
      //         user_id: 15,
      //         created_at: '2025-04-05T17:07:49.000000Z',
      //         updated_at: '2025-04-05T17:07:49.000000Z',
      //         file_path: 'storage\/art-object\/87\/165.jpg'
      //       }
      //     },
      //     {
      //       id: 18,
      //       user_id: null,
      //       art_object_id: 87,
      //       email: 'andreea.lupu@scriptics.ro',
      //       name: 'Andreea-Monica LUPU',
      //       phone_number: '0740241423',
      //       offer: 'no-price',
      //       details: 'lallalaa',
      //       status: 2,
      //       created_at: '2025-04-05T17:08:16.000000Z',
      //       updated_at: '2025-04-05T17:08:33.000000Z',
      //       art_object: {
      //         id: 87,
      //         title: 'tablou 8 martie',
      //         description: 'Tablou cu art print de 8 martie',
      //         picture_category_id: 5,
      //         availability: 0,
      //         dimension: '20x30cm',
      //         technique: 'art print',
      //         year: 2025,
      //         file_name: '165.jpg',
      //         price:  null,
      //         user_id: 15,
      //         created_at: '2025-04-05T17:07:49.000000Z',
      //         updated_at: '2025-04-05T17:07:49.000000Z',
      //         file_path: 'storage\/art-object\/87\/165.jpg'
      //       }
      //     }
      //   ];
      //   this.offers = data;
      //   if (this.offers.length > 0){
      //     this.modifyDataUpdated();
      //   }
      //   this.isLoaderVisible = false;
      //   this.isDataReady = true;
      //   setTimeout(() => {
      //     this.initiateLazyLoad();
      //   }, 0);
      });
  }

  initiateLazyLoad(): void {
    // tslint:disable-next-line:no-shadowed-variable
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    this.lazyElements.forEach(element => observer.observe(element.nativeElement));
  }
  sendEmails(offer: any, state: any): void {
    if (state === '1') {
      state = 'pending';
    } else {
      state = 'approved';
    }
    const message = 'Artistul ' + this.loggedInUser.full_name + ' a schimbat starea ofertei cu numarul ' + offer.id +
      ' primite de la userul ' + offer.name + ' in \'' + state + '\'';

    this.api.SendMultipleEmails(this.loggedInUser.email, offer.email, this.loggedInUser.full_name, message, 'aa', 'bb').subscribe(data => {
    }, err => {
      this.translate.get('noConfirmationEmail').subscribe(msg => {
        this.snackBar.open(msg, '',
          {duration: 3000, panelClass: 'error-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
        this.isLoaderVisible = false;
      });
    });
  }
  changeOfferState(selectedOffer: any, event: any): void {
    this.isLoaderVisible = true;
    console.log('selectedOffer', selectedOffer);
    console.log('event', event);
    // @ts-ignore
    this.api.postOfferEdit(selectedOffer.id, {status: event.value}).subscribe(data => {
        // @ts-ignore
        this.sendEmails(selectedOffer, event.value);
        this.isLoaderVisible = false;
        this.translate.get('modificationSuccessfullyMade').subscribe(message => {
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'success-snack-bar',
              horizontalPosition: 'end', verticalPosition: 'top'});
        });
      },
      error => {
        console.log('postOfferEdit error', error);
        this.translate.get('errorOccurred').subscribe(message => {
          this.snackBar.open(message, '',
            {duration: 3000, panelClass: 'error-snack-bar', horizontalPosition: 'end', verticalPosition: 'top'});
          this.isLoaderVisible = false;
        });
      });
  }
  ngOnInit(): void {
    if (this.loggedInUser.role_id !== 3) {
      this.getOffers();
    }
  }

}
